<template>
    <div id="room-page" v-if="roomlist.length > 0">
      <div class="rooms-gallery -reverse -light"> 
        <div class="">
            <div class="drip-line"></div>
            <div class="section-title">{{ room.room_name }}</div><div class="content">{{ room.room_name_eng }}</div>
        </div>
        <div>
          <img class="room-main-image" :src="pathheader + '//rich-sunshine.tw/sources/room/' + room.main_img.room_number + '/' + room.main_img.image + '.jpg'" alt="" >
        </div>
      </div>
      <div>
      <div class="drip-line light"></div>
      <div class="room-detail-wrapper">
      <div class="room-detail-top container">
        <div class="room-info">
            <h4>房型資訊</h4><br/>
            <p class="card-text ">入住人數：最多 {{ room.room_person }} 位</p>
            <p class="card-text">定價：NTD$ {{ room.room_price }}</p>
            <p class="card-text " hidden>坪數：</p>
            <p class="card-text ">所在建築：{{ room.room_building || 'A' }}棟</p>
            <p class="card-text ">景觀：{{ room.room_view || '山景' }}</p>
            <p class="card-text  tags">房號：<span class="tag_btn" v-for="(rn, $index) in room.roomNumbers" :key="$index" >{{ rn.room_number}}</span></p>
            <p class="card-text ">床型尺寸：<span v-if="room.bed_size === 'single'">2單人床</span><span v-if="room.bed_size === 'queen'">{{ room.room_person / 2 }}中床</span><span v-if="room.bed_size === 'king'">{{ room.room_person / 2 }}大床</span></p>
            </br>
        </div>
        <div>
        </div>
      </div>
      <div class="room-detail-bottom container">
        <div class="room-info">
            <h4>客房描述</h4>
            {{ room.room_info }}
        </div>
        <div></div>
      </div>
      </div>
      <div class="room-detail-bottom reverse container">
        <div class="room-info">
            <h4>設施與備品</h4>
            {{ room.room_equipment }}
            <br/><br/>
        </div>
        <div></div>
      </div>
      <div class="drip-line light right"></div>
      <div class="rooms-gallery -reverse -light">
        <carousel id="owl-demo2" class="swiper" :autoplay="true" :perPage="1" :perPageCustom="[[768, 2], [1024, 3]]" >
            <slide v-for="(r, $index) in room.roomImages" :key="$index" >
                <div class="accomodation_item text-center" >
                    <div class="hotel_img" style="margin:0 10px;">
                        <img :src="pathheader + '//rich-sunshine.tw/sources/room/' + r.room_number + '/' + r.image + '.jpg'" alt="" style="height: 270px;width: 100%;object-fit: cover;border-radius:10px;">
                    </div>
                </div>
            </slide>
        </carousel>
      </div>
    </div>
        <div class="container room-price-container">
      <div class="room-info-icon">B</div>
      <h3 class="room-info-terms-title is-2020" v-if="initConfig.hide_is_2020 == 0">2020房價表</h3>
      <div class="room-price-terms is-2020" v-if="initConfig.hide_is_2020 == 0">
        <div class="room-price"><div>定價</div>NTD$ {{ room.room_price }} </div>
        <div class="room-price"><div>一般平日</div>NTD$ {{ room.room_price * 0.5 }} </div>
        <div class="room-price"><div>一般假日;寒暑平日</div>NTD$ {{ room.room_price * 0.6  }} </div>
        <div class="room-price"><div>連續假日;寒暑假日</div>NTD$ {{ room.room_price * 0.7 }} </div>
        <div class="room-price"><div>過年</div>NTD$ {{ room.room_price * 0.95 }} </div>
      </div>
      <br/>
      <div v-for="(year, index) in allYears" :key="index"> 
        <h3 class="room-info-terms-title is-2021" v-if="initConfig['hide_is_' + year] == 0">{{year}}房價表-{{ room.room_name }}</h3></h3>
        <div class="room-price-terms is-2021" v-if="initConfig['hide_is_' + year] == 0">
          <div class="room-price"><div>定價</div>NTD$ {{ room.room_price }} </div>
          <div class="room-price"><div>一般平日</div>NTD$ {{ (room.roomRates[year] || {}).normal || '-' }} </div>
          <div class="room-price"><div>一般假日;寒暑平日</div>NTD$ {{ (room.roomRates[year] || {}).weekend || '-'  }} </div>
          <div class="room-price"><div>連續假日;寒暑假日</div>NTD$ {{ (room.roomRates[year] || {}).holiday || '-' }} </div>
          <div class="room-price"><div>過年</div>NTD$ {{ (room.roomRates[year] || {}).newyear || '-' }} </div>
        </div>
      </div>

      <ul class="room-price-note">
        <li>假日： 週五、週六<br/>
            平日： 週日至週四<br/></li>
        <li>旺日： 跨年元旦、連續假日及其前夕與農曆春節期間<br/>
            一般日：旺日、寒暑假除外</li>
        <li>農曆春節假期以及寒暑假期間之定義請依本民宿公告規定為準。</li>
        <li>以上平日、假日、連續假日等定義如有更動，請依官網公告為主，恕不另行個別通知。</li>
      </ul>
    </div>
    <div class="container">
      <div class="room-info-icon">i</div>
      <h3 class="room-info-terms-title">注意事項</h3>
      <ul class="room-info-terms">
        <li>請先閱讀了解後再進行訂房，預訂即表示同意以下須知與規定：</li>
      </ul>
      <ul class="room-info-terms d-none">
        <li><b><h3>入住時間 15:00 | 最晚辦理入住時間 21:00 | 最晚管家服務時間 22:00 | 退房時間 11:00 </h3></b></li>
        <li>由於所在位置偏山區，無法完全避免<b> <趨光性昆蟲、蚊蟲、壁虎或蜘蛛> </b>出現。我們在做房務清潔時都會特別留意! 但若無法接受之旅人，請您酌量考量是否訂房。
            尤以夏季蚊蟲較多，請住宿房客隨手關紗窗，以免蚊蟲打擾您的住宿品質。</li>
        <li>大自然蟲鳴鳥叫也是我們的特色哦，若無法接受青蛙、小鳥、蟬、蟋蟀等大自然動物及昆蟲的叫聲，請您酌量考量是否訂房。</li>
        <li><b>所有客房、客房陽台及室內區域全面禁菸。</b></li>
        <li>請依照房型人數入住。僅有<b>部分房型</b>才有提供加床服務，且最多加床一位。</li>
        <li>
          可加床房型 |<br/>
          VIP海景四人房 & VIP山海景六人房 & VIP精緻六人房
        </li>
        <li>
          加床加人規定 |<br/>
          若入住超過房型人數，<br/>
          6歲以下之幼童，可免費與大人一同入住(免費同住，最多2位)；<br/>
          6歲以上、11歲以下孩童，需以加人或*加床方式付費入住；<br/>
          超過11歲（或成人），則視為占床入住，若超過房型人數，依各房型加床規定，須額外付費*加床入住，或另訂其他房型。<br/>
          
          免費同住 | 不另供早餐與床品、備品。<br/>
          加人 | 含早餐一客，一人份備品(含毛浴巾，不含床被枕)<br/>
          加床 | 含早餐一客，一人份備品(含毛浴巾)及單人厚床墊(含單人被與枕)<br/>
        </li>
      </ul>
    </div>
        <section class="blog_categorie_area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="categories_post">
                            <img src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="post">
                            <div class="categories_details" @click="goPreknow()">
                                <div class="categories_text">
                                    <h5>訂房前須知&住宿約定</h5>
                                    <div class="border_line"></div>
                                    <p>想來度假嗎，相信您是個好旅人對吧</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="categories_post">
                            <img src="../assets/news/photo-1574834892631-f773d4c7f3e7.jpg" alt="post">
                            <div class="categories_details" @click="goRegulation()">
                                <div class="categories_text">
                                    <h5>訂房流程&取消規定</h5>
                                    <div class="border_line"></div>
                                    <p>先了解訂房與取消規定，更快速的完成預訂</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="categories_post">
                            <img src="../assets/news/photo-1574834892631-f773d4c7f3e7.jpg" alt="post">
                            <div class="categories_details" @click="goQA()">
                                <div class="categories_text">
                                    <h5>Q & A</h5>
                                    <div class="border_line"></div>
                                    <p>更多入住旅遊交通等相關疑問，先來這邊找答案</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    <div class="container room-more-container" v-if="roomMoreReady">
        <h4>MORE</h4>
        <h3 id="currentSuggest">{{ suggest === 'type' ? '其他同房型推薦' : '其他同棟推薦' }}</h3>
        <h4 id="otherSuggest" @click.stop="triggerSuggest()">{{ suggest === 'type' ? '其他同棟推薦' : '其他同房型推薦' }}</h4>
        <div class="row mb_30 room-more-type">
            <div class="rooms-gallery -reverse">
                <carousel id="owl-demo3" class="swiper" :autoplay="false" :perPage="1" :perPageCustom="[[768, 2], [1024, 3]]" >
                  <slide class="" v-for="(room, index) in roomsMore" :key="index" @click.stop="goRoomType(room.room_name_eng)">
                      <div class="accomodation_item text-center" >
                          <div class="hotel_img" style="margin:0 10px;">
                              <img :src="pathheader + '//rich-sunshine.tw/sources/room/' + room.main_img.room_number + '/' + room.main_img.image + '.jpg'" alt="" style="height: 270px;width: 100%;object-fit: cover;border-radius:10px;">
                              <div @click.stop="goRoomType(room.room_name_eng)" class="theme_btn button_hover">VIEW NOW</div>
                          </div>
                          <div @click.stop="goRoomType(room.room_name_eng)" ><h4 class="sec_h4">{{room.room_building}}棟 x {{room.room_name}}</h4></div>
                          <h5 class="d-none"><small>平日 </small>-<small>起/night </small></h5>
                      </div>
                  </slide>
                </carousel>
            </div>
        </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'
const pathheader = window.location.protocol
export default {
  name: 'room',
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      initConfig: {},
      roomMoreReady: false,
      id: '',
      suggest: 'type',
      room: {},
      roomlist: [],
      pathheader: pathheader,
      allYears: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
    }
  },
  computed: {
    roomsMore () {
      return this.suggest === 'build' ? this.roomsMoreSameBuild : this.roomsMoreSameType
    },
    roomsMoreSameBuild () {
      let list = this.roomlist.filter(r => {
        let roomImages = []
        if (r.room_building === this.room.room_building && r.room_id !== this.room.room_id) {
          r.roomNumbers.forEach((roomNumber) => {
            roomImages = roomImages.concat(roomNumber.images)
          })
          r.main_img = roomImages[0]
          return r && r.room_suspend === '0'
        }
      })
      console.log(list)
      return list || []
    },
    roomsMoreSameType () {
      let list = this.roomlist.filter(r => {
        let roomImages = []
        if (r.room_person === this.room.room_person && r.room_id !== this.room.room_id) {
          r.roomNumbers.forEach((roomNumber) => {
            roomImages = roomImages.concat(roomNumber.images)
          })
          r.main_img = roomImages[0]
          return r && r.room_suspend === '0'
        }
      })
      console.log(list)
      return list || []
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getInitConfig()
    this.getRooms()
    this.triggerSuggest()
  },
  methods: {
    getInitConfig () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getWebConfig', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        const res = response.data
        res.data.forEach(dt => {
          // console.log(dt)
          this.initConfig[dt.key] = dt.value
        })
      })
      .catch((errorResponse) => {
        // console.log(errorResponse)
      })
    },
    triggerSuggest () {
      if (this.suggest === 'type') {
        this.suggest = 'build'
      } else {
        this.suggest = 'type'
      }
      this.roomMoreReady = true
      this.$ga.event('room', 'view-other-room', 'roomtype-' + this.suggest, 1)
    },
    getRooms () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getRooms', {withCredentials: true})
      .then((response) => {
        if (!response.data.success) {
          this.room = {}
          return
        }
        const res = response.data
        this.roomlist = res.data
        this.room = res.data.filter(r => {
          let trimRoomNameEng = r.room_name_eng.split(' ').join('')
          // console.log(this.id, trimRoomNameEng)
          return trimRoomNameEng === this.id
        })[0]
        // console.log(this.room)

        let roomImages = []
        this.room.roomNumbers.forEach((roomNumber) => {
          roomImages = roomImages.concat(roomNumber.images)
        })
        this.room.roomImages = roomImages
        this.room.main_img = roomImages[0]

        let roomRates = {}
        console.log(this.room.roomRates[0])
        this.room.roomRates.forEach((roomRate) => {
          console.log(roomRates, roomRate.year)
          if (roomRates.hasOwnProperty(roomRate.year)) {
            roomRates[roomRate.year].push(roomRate)
          } else {
            roomRates[roomRate.year] = roomRate
          }
        })
        this.room.roomRates = roomRates
        console.log('>>', this.room)
      })
      .catch((errorResponse) => {
        this.room = {}
      })
    },
    goRoomType (roomNameEng) {
      console.log(roomNameEng)
      let trimRoomNameEng = roomNameEng.split(' ').join('')
      console.log(trimRoomNameEng)
      this.$ga.event('room', 'click-suggest-room', 'room-' + trimRoomNameEng, 1)
      this.$router.push({name: 'RoomType', params: {id: trimRoomNameEng}})
    },
    goPreknow () {
      this.$ga.event('know', 'click-know', 'preknow', 1)
      this.$router.push({name: 'Know'})
    },
    goRegulation () {
      this.$ga.event('know', 'click-know', 'regulation', 1)
      this.$router.push({name: 'Regulation'})
    },
    goQA () {
      this.$ga.event('know', 'click-know', 'QA', 1)
      this.$router.push({name: 'QA'})
    }
  }
}
</script>
<style lang="scss" scoped>
$room-info-color: #5C5C5C;
.room-more-container {
    margin-bottom: 35px;
    padding-top: 11px;
    border-top: 1px solid #dfdfdf;
    h4 {
      color: #5b5b5b;
      font-weight: 700;
      font-size: 16px;
      letter-spacing: .1em;
      text-transform: uppercase;
      margin-bottom: 28px;
    }
    .room-more-type, .room-more-build {
      margin-bottom: 20px;
    }
    .room-more-type .single-recent-blog-post .details {
      background-color: darksalmon;
    }
    .room-more-build .single-recent-blog-post .details {
      background-color: rgb(147, 193, 120)
    }
    #otherSuggest {
      color: #52c5fd;
      opacity: .7;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
}
.rooms-gallery {
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 60px 0;
    position: relative;
    margin: auto;
}
.section-title {
    margin: 40px 0 20px 0;
    color: #231815;
    text-align: center;
    font-size: 30px;
    // font-weight: 200;
    letter-spacing: 2px;
    line-height: 1;
    word-break: keep-all;
}
.drip-line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    background: #333;
    width: 1px;
    height: 80px;
    margin: 0 auto;
    -webkit-transition: .5s;
    transition: .5s;
    &.light {
      background: #f4f2ee;
    }
    &.right {
      width: 2px;
      margin-right: 36%;
    }
}
.rooms-gallery.-light {
    background: #f4f2ee;
}
.rooms-gallery.-reverse {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
}
.room-main-image {
    border-radius: 10px;
    border: 10px solid #EAE4D3;
    height: 320px;
    width: 98%;
    min-height: 300px;
    max-width: 1078px;
    object-fit: cover;
    margin: 20px 0;
    @media (min-width: 768px) {
          height: 520px;
        }
}
.room-price-container {
  max-width: 460px;
  margin-bottom: 50px;
}
.room-price-note {
  font-size: 14px;
  font-weight: 100;
  text-align: left;
}
.room-price-terms {
  margin-bottom: 24px;
}
.room-price {
  display: flex;
  border-top: 1px solid;
  border-right: 1px solid;
  border-left: 1px solid;
  padding: 5px;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 100;
  &:last-of-type {
    border-bottom: 1px solid;
  }
}
.room-detail-wrapper {
  display: flex;
  flex-direction: row;
  padding: 50px;
  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
}
.room-detail-top {
    display: flex;
    flex-direction: row-reverse;
    flex-basis: 350px;
    background: #EAE4D3;
    padding: 20px;
    border-radius: 5px;
    @media screen and (max-width: 799px) {
      flex: 1;
    }

    .tag_btn {
          background-color: #93bca8;
    color: #FFF;
    border-width: 2px;
    border-radius: 5px;
    }
    
    // font-weight: 100;
    & > div {
      flex: 0;
      &.room-info {
        flex: 1;
      }
    }
    // @media screen and (max-width: 799px) {
    //   & > div {
    //     flex: 0;
    //     &.room-info {
    //       padding: 20px 50px;
    //     }
    //   }
    // }
    // .room-info {
    //   position: relative;
    //   &:before {
    //       content: '';
    //       width: 50px;
    //       height: 100%;
    //       /* background: red; */
    //       position: absolute;
    //       left: -50px;
    //       border-top: 3px solid #f4f2ee;
    //       border-left: 2px solid #f4f2ee;
    //   }
    // }
}
.room-detail-bottom {
    display: flex;
    flex-direction: row;
    flex: 1;
    // font-weight: 100;
    padding: 50px;
    border-bottom: 2px solid #f4f2ee;
    &.reverse {
      flex-direction: row-reverse;
      border: 0;
    }
    & > div {
      flex: 0;
      &.room-info {
        flex: 2;
      }
    }
    @media screen and (max-width: 799px) {
      & > div {
        flex: 0;
      }
    }
}
.room-info-icon {
  color: #f4f2ee;
  font-size: 36px;
  font-weight: 800;
  border: 3px solid #f4f2ee;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
  margin: 20px auto;
}
.room-info-terms-title {
  text-align: left;
}
.room-info-terms {
  font-size: 16px;
  font-weight: 100;
  text-align: left;
}

#room-page {
    .room-title {
      margin-top: 100px;
      padding: 50px 0;
      font-size: 24px;
    }
    .navgator {
        padding: 5px;
        display: flex;
        justify-content: center;
        flex-flow: wrap;
        background: #222;
        & > div {
            padding: 5px;
            border: 1px solid #55b3ac;
            color: #55b3ac;
            margin: 5px;
            cursor: pointer;
            &.active {
                background: brown;
                color: white;
                border-color: white;
            }
        }
    }
    .promote {
        background: lightsalmon;
        color: white;
        padding: 5px 10px;
        border-radius: 10px;
        font-size: 8px;
        margin-left: 10px;
        letter-spacing: 1px;
    }
    .room-intro {
        // background-image: url(https://static.wixstatic.com/media/071c77d7707a470991d5a3fdc0e57464.jpg);
        background-size: cover;
        color: #fff;
        position: relative;
        .bg {
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            .progressive-image {
                object-fit: cover !important;
            }
        }
        .intro {
            z-index: 1;
            position: relative;
        }
        .lead {
            margin-top: 5rem;
            letter-spacing: 2px;
            font-size: 1rem;
        }
        .room-intro-title {
            position: relative;
        }
        .room-intro-title:after,
        .room-intro-title:before {
            content: '';
            width: 100px;
            height: 1px;
            display: block;
            background: white;
            position: absolute;
            top: 12px;
        }
        .room-intro-title:after {
            left: -110px;
        }
        .room-intro-title:before {
            right: -110px;
        }
        .room-intro-blocks {
            margin-top: 5rem;
            text-shadow: 1px 1px 10px rgba(0,0,0,.1);
            .card-block {
                background-color: rgba(255, 255, 255, .5);
                padding: 1.25rem;
                @media (min-width: 768px) {
                    padding-top: 5rem;
                    padding-bottom: 5rem;
                }
                .card-text {
                    font-size: 26px;
                    font-weight: 100;
                    // text-shadow: black 2px 1px 30px;
                }
                .short-border {
                    width: 4rem;
                    height: 1px;
                    background: #fff;
                    margin: 0 auto 2rem auto;
                }
            }
        }
    }
    .room-notice {
      color: $room-info-color;
      .definition {  
        padding: 20px;
        margin-bottom: 100px;
        position: relative;
        text-align: left;
        border-left: 2px solid;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
    .room-kinds {
        color: $room-info-color;
        margin-top: 10px;
        .definition {  
            padding: 20px;
            margin-bottom: 100px;
            position: relative;
            text-align: left;
            border-left: 2px solid;
            font-weight: 300;
            letter-spacing: 1px;
        }
        .card {
            margin-bottom: 2rem;
            border-top: 5px solid rgba(0, 0, 0, 1);
            border-radius: 0;
            .room-simple > div {
              padding: 0;
            }
        }
        .card-block {
            overflow: auto;
            padding: 1.25rem;
        }
        .card-name {
          background: black;
          color: white;
          @media (min-width: 992px) {
            writing-mode: tb-rl;
          }
          .card-title {
            font-weight: 400;
            margin: 0;
            .eng {
              font-size: 10px;
              font-weight: 100;
            }
          }
        }
        .room-info-container:hover .see-more:after {
          max-height: 10px;
        }
        .room-info {
          cursor: pointer;
          font-size: 16px;
          color: #2f2f2f;
          line-height: 1.8;
          font-weight: 300;
          padding-bottom: 60px;
          @media (min-width: 768px) {
              padding-bottom: 50px;
          }
          h4 {
            margin-bottom: 30px;
            font-size: 20px;
            color: #000;
            letter-spacing: 2px;
            text-align: left;
            &:after {
                content: "";
                display: block;
                margin-top: 10px;
                width: 60px;
                height: 2px;
                background: #c9c9c9;
            }
          }
        }
        .price-info {
            padding: .5rem 2rem;
            border: 2px solid;
            float: right;
        }
        .room-people {
            font-size: 20px;
            padding: 10px;
        }
        .room-items {
            text-align: left;
            span {
                font-size: 30px;
                padding: 10px;
            }
        }
        .more-btn {
            position: absolute;
            bottom: 1.25rem;
            cursor: pointer;
        }
        .see-more-close {
          cursor: pointer;
          position: absolute;
          right: 30px;
          top: 0px;
           &:hover:before {
             max-height: 8px;
           }
           &:before {
            content: "";
            display: block;
            margin: 0 auto 8px auto;
            width: 1px;
            height: 15px;
            max-height: 15px;
            background: #fff;
            transition: all 0.4s ease;
           }
        }
        .see-more {
          cursor: pointer;
          position: absolute;
          left: 50%;
          bottom: 0;
          font-size: 15px;
          color: #000;
          transform: translateX(-50%);
          &:after {
            content: "";
            display: block;
            margin: 8px auto 0 auto;
            width: 2px;
            height: 30px;
            max-height: 30px;
            background: #000;
            transition: all 0.4s ease;
          }
        }
        .room-detail {
            margin: 0 auto;
            text-align: left;
            padding: 2rem 1rem;
            -webkit-transition: 1s ease-in-out;
            transition: 1s ease-in-out;
            // max-width: 700px;
            height: 0;
            overflow: auto;
            // overflow: hidden;
            &.more {
                // margin: 2rem auto 2rem auto;
                // height: auto;
                height: 100%;
                position: absolute;
                top: 0;
                z-index: 1;
                background: rgba(0,0,0,.5);
                color: white;
            }
            .short-border {
                width: 10rem;
                height: 1px;
                background:  rgba(0, 0, 0, 0.125);
                margin: 0 auto 2rem auto;
            }
        }
    }
    .card-img-top {
        color: #fff;
        height: 350px;
        @media (min-width: 768px) {
            height: 350px;
        }
        // background: url(https://static.wixstatic.com/media/a5f08ab2f8a3414aa4daa927910f1ea5.jpg) center no-repeat;
        // background-size: cover;
    }
}
.swiper-container {
background-color: #000;
    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        object-position: 50% 50%;
    }
}
.swiper-slide {
background-size: cover;
background-position: center;
}
.gallery-top {
height: 100%!important;
width: 100%;
}
.gallery-thumbs {
height: 20%!important;
box-sizing: border-box;
padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
width: 25%;
height: 100%;
opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/RoomTypeV2.vue